import { graphql } from "msw";
import {
  getShopProduct,
  getShopProductVariables
} from "../app/graphql/types/getShopProduct";
import {
  getProductCollectionByHandle,
  getProductCollectionByHandleVariables
} from "../app/graphql/types/getProductCollectionByHandle";
import { getProductCollectionByHandleSuccessResponse } from "./fixtures/getProductCollectionByHandle";
import { getShopProductSuccessResponse } from "./fixtures/getShopProduct";

export const handlers = [
  graphql.query("getAccountPatientsPharmacy", (req, res, ctx) => {
    return res(
      ctx.data({
        account: {
          __typename: "Account",
          id: "acc_123",
          patients: {
            __typename: "AccountPatientConnection",
            edges: [
              {
                __typename: "AccountPatientEdge",
                node: {
                  __typename: "Patient",
                  id: "pat_123",
                  isAccountHolder: true,
                  pdsPharmacy: {
                    __typename: "Pharmacy",
                    name: "Crossley F (Chemists) Ltd",
                    addressCity: "Blackpool",
                    odsCode: "FLA06"
                  }
                }
              }
            ]
          }
        }
      })
    );
  }),

  graphql.query("getAccount", (req, res, ctx) => {
    return res(
      ctx.data({
        account: {
          __typename: "Account",
          id: "acc_123",
          verifiedEmail: true,
          verifiedPhone: true,
          email: "test@test.com",
          phoneNo: "+447447017461",
          intercomId: "intercom_id",
          hasIM1Enabled: false,
          hasNhsLoginEnabled: false,
          patients: {
            __typename: "AccountPatientConnection",
            edges: [
              {
                __typename: "AccountPatientEdge",
                node: {
                  __typename: "Patient",
                  id: "pat_123",
                  isAccountHolder: true,
                  firstName: "First",
                  lastName: "Last",
                  pdsTraceAttemptsRemaining: 3,
                  pdsRetrieveAttemptsRemaining: 2,
                  nhsNumber: "57546754764",
                  practice: {
                    __typename: "Practice",
                    id: "prac_123"
                  }
                }
              }
            ]
          }
        }
      })
    );
  }),

  graphql.mutation("requestNomination", (req, res, ctx) => {
    return res(
      ctx.data({
        requestNomination: {
          __typename: "RequestNominationResponse",
          patient: {
            __typename: "Patient",
            id: "pat_123"
          }
        }
      })
    );
  }),

  graphql.query<getShopProduct, getShopProductVariables>(
    "getShopProduct",
    (req, res, ctx) => {
      return res(ctx.data(getShopProductSuccessResponse));
    }
  ),

  graphql.query<
    getProductCollectionByHandle,
    getProductCollectionByHandleVariables
  >("getProductCollectionByHandle", (req, res, ctx) => {
    return res(ctx.data(getProductCollectionByHandleSuccessResponse));
  })
];
